import { useSettings } from "@/context/SettingsContext";
import { MessageCircle } from "lucide-react";

const cleanPhone = (p) => (p || "").replace(/[^0-9+]/g, "");

export default function WhatsAppButton() {
  const { settings } = useSettings();
  const raw = cleanPhone(settings?.phone || "0645142965");
  // Convert French 06/07 into international +33 format for WhatsApp
  let intl = raw;
  if (intl.startsWith("0")) intl = "+33" + intl.slice(1);
  if (!intl.startsWith("+")) intl = "+" + intl;
  const msg = encodeURIComponent(
    "Bonjour DAS SIMAO AUTO, je souhaite obtenir un renseignement.",
  );
  const href = `https://wa.me/${intl.replace(/[^0-9]/g, "")}?text=${msg}`;

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-float-btn"
      aria-label="Contacter DAS SIMAO AUTO sur WhatsApp"
      className="fixed bottom-5 right-5 z-50 group"
    >
      <div className="relative">
        <div className="absolute inset-0 bg-[#25D366] rounded-full animate-ping opacity-40" />
        <div className="relative w-14 h-14 rounded-full bg-[#25D366] hover:bg-[#128C7E] transition-colors shadow-[0_8px_24px_rgba(37,211,102,0.4)] flex items-center justify-center">
          <MessageCircle size={26} className="text-white" fill="white" />
        </div>
        <span className="absolute right-full mr-3 top-1/2 -translate-y-1/2 whitespace-nowrap bg-black/90 text-white text-xs px-3 py-2 opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none">
          Discutons sur WhatsApp
        </span>
      </div>
    </a>
  );
}
